import type { PublicAiPhotoLook, SceneId, StyleId } from '@ai-photo-style/shared';
import type { EmbedVariant } from '../config';
import cutPaper from './examples/cut-paper.webp';
import huisdierMand from './examples/huisdier-mand.webp';
import kinderenWieg from './examples/kinderen-wieg.webp';
import lineArt from './examples/line-art.webp';
import oudersLijn from './examples/ouders-lijn.webp';
import storybook from './examples/storybook.webp';
import vintage from './examples/vintage-waterverf.webp';
import family from './examples/gezin-waterverf.webp';

/** Voorbeeld per stijl. Vite zet ze als data-URL in de IIFE, zodat ze op de shop-PDP laden. */
export const STYLE_EXAMPLES: Record<StyleId, string> = {
  'vintage-waterverf': vintage,
  'line-art': lineArt,
  storybook,
  'cut-paper': cutPaper,
};

/** Voorbeeld per scène, met alfakanaal, net als de stijlvoorbeelden inline in de bundle. */
export const SCENE_EXAMPLES: Record<SceneId, string> = {
  'huisdier-mand': huisdierMand,
  'ouders-lijn': oudersLijn,
  'kinderen-wieg': kinderenWieg,
};

export function exampleFor(look: PublicAiPhotoLook, variant: EmbedVariant): string | undefined {
  if (look.previewUrl !== null) return look.previewUrl;
  if (variant === 'scenes' && look.id === 'vintage-waterverf') return family;
  if (Object.hasOwn(SCENE_EXAMPLES, look.id)) return SCENE_EXAMPLES[look.id as SceneId];
  if (Object.hasOwn(STYLE_EXAMPLES, look.id)) return STYLE_EXAMPLES[look.id as StyleId];
  return undefined;
}
